<template>
  <div class="top">
     <div class="exam_subject">
       <span>{{this.$route.query.paperName+"("+this.$route.query.paperScore+"分"+"/"+this.$route.query.count+"题"+")"}}</span>
     </div>

     <div class="exam_time" v-if="!userType">
       <b class="downTime" v-if="isTime !== 'none'">{{countDown}}</b>
       <span style="background:white;color:rgba(131,182,255,1);border-color:white; " v-if="this.showBack" @click="back">返回</span>
       <span v-if="!this.showBack" @click="submitTest">交卷</span>
     </div>
  </div>

</template>

<script>
	import * as api from "../../../../../api/testExamApi";
  import {moduleId} from "../../../../../store/modules/exam";
  import {mapState, mapMutations, mapActions, mapGetters} from 'vuex';
    export default {
        data(){
            return{
                countDown:null,
                examCardno: null,
                downTime:null,
                isTime: this.$route.query.isTime,
                flag:0, //跳转到交卷  如果flag是0 是时间到 1 是手动交卷
                userType: this.$route.query.userType
            }
        },
      computed:{
        ...mapState(moduleId, {
          paperData: state => state.paperData,
          showBack: state => state.showBack,
          isShowLeft: state => state.isShowLeft,
        }),
      },
         watch:{
            paperData(newVal){
              // console.log(newVal)
               if(this.isTime === 'none'){
                   return false
               }
               if(this.$route.query.type==1){
                   let endTime = new Date(newVal.examPaper.startAnswerTime).getTime() + newVal.examCourse.examTime * 60 * 1000;
                   let currentTime =  new Date(this.paperData.examPaper.currentDate).getTime();
                   if(endTime >= currentTime ){
                       this.downTime = endTime - currentTime;
                       window.time = setInterval(()=>{
                           if(this.downTime <= 0){
                               clearInterval(window.time);
                               this.flag = 0;
                               this.submitPaper();
                           }
                           this.countDown = this.countTime(this.downTime-1000);
                           this.downTime = this.downTime-1000;
                       },1000);
                   }else{
                     //跳转到交卷  如果flag是0 是时间到 1 是手动交卷
                      this.flag = 1;
                      this.submitPaper();
                   }

               }
            }
        },
        methods:{
          ...mapMutations(moduleId,['SHOW_OPTIONS','SHOW_BACK','SHOW_LEFT']),
          back(){
            $(".content_box").css("flex-direction","column");
            $("#wrapMain").css({
              "height":"100%",
              "width":"100%",
            });
            this.SHOW_OPTIONS(false);
            this.SHOW_BACK(false);
            this.SHOW_LEFT(true);
          },
          countTime(value) {
               var differTime = value;
               //定义变量,h,m,s保存倒计时的时间
               var h, m, s;
               if (differTime >= 0) {
                 h = Math.floor(differTime / 1000 / 60 / 60);
                 m = Math.floor(differTime / 1000 / 60 % 60);
                 s = Math.floor(differTime / 1000 % 60);
                 h = h < 10 ? ("0" + h) : h;
                 m = m < 10 ? ("0" + m) : m;
                 s = s < 10 ? ("0" + s) : s;
                 var timeDom = h + " : " + m +  " : " +  s ;
                 return timeDom;
                 //递归调用函数所以是延时器不是定时器

               }
          },
          submitTest(){
          	api.submitTest(this.paperData.examPaperId,this.$route.query.paperId).then((result)=>{
              if(result.code === "1"){
                const h = this.$createElement;
                this.$msgbox({
                  title: '交卷确认',
                  message: h('p', null, [
                    h('span', null, `共${result.data.count}题，已答${result.data.finish}题， 未答`),
                    h('i', { style: 'color: red' }, ` ${result.data.notFinish}`),
                    h('span',null, ' 题'),
                  ]),
                  showCancelButton: true,
                  confirmButtonText: '确定',
                  cancelButtonText: '取消',
                }).then(() => {
                  this.submitPaper();
                }).catch(() => {
                  this.$message({
                    type: 'info',
                    message: '已取消'
                  });
                });
              }else if(result.code === "2"){
                const h = this.$createElement;
                this.$msgbox({
                  title: '交卷确认',
                  message: h('p', null, [
                    h('span', null, `作答已完成`),
                  ]),
                  showCancelButton: true,
                  confirmButtonText: '确定',
                  cancelButtonText: '取消',
                }).then(() => {
                  this.submitPaper();
                }).catch(() => {
                  this.$message({
                    type: 'info',
                    message: '已取消'
                  });
                });
              }else if(result.code === "3"){
                 this.$messageError(result.msg)
              }
            });

          },
          submitPaper(){
            if(window.time){
                    clearInterval(window.time)
            }
          	api.submitExam(this.paperData.examPaperId,this.$route.query.classId).then((result)=>{
              if(result.code === "0"){
                // this.$messageSuccess("交卷成功！");

                let obj= {
                  catalogId: this.$route.query.catalogId,//当前学习的目录id
                  courseId: this.$route.query.id,//课程id
                  resourceId: Number(this.$route.query.paperId),//当前学习的资源id
                  classId: this.$route.query.classId,
                  isEnd: 1,// 0 未看完，1，已看完 。资源是否看完
                  seatno: 1,//资源学习次数
                  resProgress: 1,//这条资源最后一次学习的时间
                  totalResNum: 0,//总资源数
                  resourceType: 10
                };
                console.log(obj);
                this.insertDirectory(obj);
                 if(this.flag==0){
                     this.$router.push({
                      path: '/switch/test/success',
                      query: {
                        id: this.$route.query.id,
                        classId: this.$route.query.classId,
                        userId: sessionStorage.getItem('userId'),
                        paperId: this.$route.query.paperId,
                        total: this.$route.query.total,
                        className: this.$route.query.className,
                        catalogId: this.$route.query.catalogId,
												paperCode: this.$route.query.paperCode,
												examId: this.$route.query.examId,
                        flag:result.data,
                        value:0,
                        finishFlag:0,
                        isShowScore: this.$route.query.isShowScore
                      }
                    });
                  }else{
                    this.$router.push({
                      path: '/switch/test/success',
                      query: {
                        id: this.$route.query.id,
                        classId: this.$route.query.classId,
                        userId: sessionStorage.getItem('userId'),
                        paperId: this.$route.query.paperId,
                        total: this.$route.query.total,
                        className: this.$route.query.className,
                        catalogId: this.$route.query.catalogId,
												paperCode: this.$route.query.paperCode,
												examId: this.$route.query.examId,
                        flag:result.data,
                        value:1,
                        finishFlag:0,
                        isShowScore: this.$route.query.isShowScore
                      }
                    });
                  }

              }
            })
          },
          insertDirectory(data) {
          	api.addToResRecord(data).then(rs => {
                // console.log(rs);
              })
              .catch(function (error) {
                console.log(error);
              });
          },
        },
        mounted() {

        }
    }
</script>

<style lang="scss" scoped>
.top{
  width: 100%;
  height: 60px;
  line-height: 60px;
  background:linear-gradient(90deg,rgba(83,151,247,1) 0%,rgba(111,146,255,1) 100%);
  display: flex;
  div{
    flex: 1;
  }
  .exam_subject{
    color:rgba(255,255,255,1);
    padding-left: 2%;
     span:nth-child(1){
       font-size:14px;
     }
    span:nth-child(2){
      font-size:16px;
    }
  }
  .name{
    color:rgba(255,255,255,1);
    span:nth-child(1){
      font-size:14px;
    }
    span:nth-child(2){
      font-size:16px;
    }
  }
  .exam_time{
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding-right: 2%;
    span{
      width:90px;
      height:30px;
      text-align: center;
      line-height: 30px;
      background:rgba(255,255,255,1);
      border:2px solid rgba(255,255,255,1);
      box-shadow:0px 2px 4px rgba(45,12,195,0.27);
      opacity:1;
      border-radius:24px;
      color:rgba(255,160,63,1);
      font-size:18px;
      cursor: pointer;
      &:hover{
        background:rgba(255,190,47,1);
        color:white;
      }
    }
  }
}
.downTime{
    /*opacity:1;*/
    /*height:30px;*/
    border-radius:24px;
    font-size:20px;
    color:rgba(255,160,63,1);
    /*float: right;*/
    margin-right: 20px;
    }
</style>



// WEBPACK FOOTER //
// src/components/views/studyCenter/switch/testComponent/header.vue